import {CKEditor} from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import React from "react";
import {getIn} from "formik";

export const CKEditorConfig = {
    language: 'fr',
    toolbar: ['heading', '|', 'bold', 'italic', 'link', 'numberedList', 'bulletedList', '|', 'undo', 'redo',],
    heading: {
        options: [
            { model: 'paragraph', title: 'Paragraphe', class: 'ck-heading_paragraph' },
            { model: 'heading2', view: 'h2', title: 'Titre 2', class: 'ck-heading_heading2' },
            { model: 'heading3', view: 'h3', title: 'Titre 3', class: 'ck-heading_heading3' },
            { model: 'heading4', view: 'h4', title: 'Titre 4', class: 'ck-heading_heading4' },
            { model: 'heading5', view: 'h5', title: 'Titre 5', class: 'ck-heading_heading5' },
        ]
    }
};

export const CKEditorConfigSimple = {
    language: 'fr',
    toolbar: [ 'bold', 'italic', '|', 'undo', 'redo' ],
};

export const CKEditorConfigSimpleWithTitles = {
    language: 'fr',
    toolbar: ['heading', '|', 'bold', 'italic', '|', 'undo', 'redo'],
    heading: {
        options: [
            { model: 'heading2', view: 'h2', title: 'Titre 2', class: 'ck-heading_heading2' },
            { model: 'heading3', view: 'h3', title: 'Titre 3', class: 'ck-heading_heading3' },
            { model: 'heading4', view: 'h4', title: 'Titre 4', class: 'ck-heading_heading4' },
            { model: 'heading5', view: 'h5', title: 'Titre 5', class: 'ck-heading_heading5' },
            { model: 'heading6', view: 'h6', title: 'Titre 6', class: 'ck-heading_heading6' },
        ]
    }
};

class StableCKEditor extends React.Component {
    constructor(props) {
        super(props);
        this.editorInstance = null;
    }

    componentDidUpdate(prevProps) {
        if (!this.editorInstance) return;
        if (prevProps.value !== this.props.value) {
            const normalize = (str) => (str || '').replace(/&nbsp;/g, ' ');
            const currentData = normalize(this.editorInstance.getData());
            if (currentData !== normalize(this.props.value)) {
                this.editorInstance.setData(this.props.value || '');
            }
        }
    }

    render() {
        const { value, onChange, config, editor } = this.props;
        return (
            <CKEditor
                editor={editor}
                config={config}
                onReady={(editorInstance) => {
                    this.editorInstance = editorInstance;
                    editorInstance.setData(value || '');
                }}
                onChange={(event, editorInstance) => {
                    onChange(editorInstance.getData());
                }}
            />
        );
    }
}

class WysiwygInputRenderer extends React.Component {
    static supports(props) {
        return ['wysiwyg'].includes(props.as ?? props.type);
    }

    render() {
        const { formikContext, name } = this.props;
        const value = getIn(formikContext.values, name);

        return (
            <StableCKEditor
                editor={ClassicEditor}
                config={CKEditorConfig}
                value={value}
                onChange={(data) => formikContext.setFieldValue(name, data)}
            />
        );
    }
}

export { StableCKEditor };
export default WysiwygInputRenderer;
